(function () {
    'use strict';

    angular
        .module('josdaviApp')
        .controller('EmploieTempsController', EmploieTempsController);

    EmploieTempsController.$inject = ['$scope', '$state', 'EmploieTemps', 'EmploieTempsSearch', 'TableService'];

    function EmploieTempsController($scope, $state, EmploieTemps, EmploieTempsSearch, TableService) {

        var vm = this;
        var addItemData = {
            templateUrl: 'app/entities/emploie-temps/emploie-temps-dialog.html',
            controller: 'EmploieTempsDialogController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'md',
            resolve: {
                entity: function () {
                    return {
                        designation: null,
                        id: null
                    };
                }
            }
        };


        /**
         *Modification d'un élément
         */
        var editItemData = {
            templateUrl: 'app/entities/emploie-temps/emploie-temps-dialog.html',
            controller: 'EmploieTempsDialogController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'md',
            resolve: {
                entity: null
            }
        };

        /**
         * Suppresion d'un élément
         */
        var deleteItemData = {
            templateUrl: 'app/entities/emploie-temps/emploie-temps-delete-dialog.html',
            controller: 'EmploieTempsDeleteController',
            controllerAs: 'vm',
            size: 'sm',
            resolve: {
                entity: null
            }
        };

        var dialogData = {
            addData: addItemData,
            editData: editItemData,
            deleteData: deleteItemData
        };
        var entitySearchParams = function () {
            return {};
        };

        var entityParams = function () {
            return {};
        };

        var datas = {
            scope: $scope,
            vm: vm,
            entity: EmploieTemps,
            entitySearch: EmploieTemps,
            dialogData: dialogData,
            entitySearchParams: entitySearchParams,
            entityParams: entityParams
        };
        TableService.init(datas);
    }
})();